module.exports = __webpack_public_path__ + "img/data-migration-grid-tile.e7629622.jpg";